export default {
  message: {
    Tour: {
      continue: "متابعة",
      back: "رجوع",
      finish: "إنهاء"
    },
    Login: {
      title: "تسجيل دخول الوالدين",
      sign_in: "تسجيل الدخول",
      login_fail: "فشل في المصادقة. يرجى المحاولة مرة أخرى أو التواصل مع المدرسة للمساعدة.",
      forgot_password: "نسيت كلمة المرور",
      create_account: "إنشاء حساب",
      password: "كلمة المرور",
      confirm_password: "تأكيد كلمة المرور",
      password_reminder: "تذكير كلمة المرور",
      enter_email: "أدخل عنوان بريدك الإلكتروني",
      validation_error: "رسالة خطأ في التحقق",
      password_reminder_error_no_user_register:
        "اسم المستخدم الذي أدخلته غير موجود. حاول مرة أخرى أو أنشئ حسابًا جديدًا.",
      password_reminder_error_no_user: "اسم المستخدم غير موجود.",
      password_reminder_sent: "تم إرسال رسالة بريد إلكتروني بها التعليمات إلى {email}.",
      password_reminder_sent_message:
        "قد تستغرق الرسالة بضع دقائق للوصول. تحقق من مجلد البريد العشوائي إذا لم تجدها.",
      password_trouble_email: "إذا استمرت المشكلة، يرجى التواصل مع {email}.",
      password_trouble_school: "إذا استمرت المشكلة، يرجى التواصل مع المدرسة.",
      return_to_sign_in: "العودة إلى تسجيل الدخول",
      create_my_account: "إنشاء حسابي",
      or_sign_in_with: "أو تسجيل الدخول باستخدام",
      password_reset: "يرجى اختيار كلمة مرور جديدة.",
      password_reset_warning: "إذا لم تطلب تغيير كلمة المرور، يرجى التواصل فورًا مع مسؤول المدرسة.",
      password_update: "اختر كلمة مرور جديدة",
      password_update_confirm: "تأكيد كلمة المرور الجديدة",
      password_update_success: "تم حفظ كلمة المرور الجديدة."
    },
    AccountSettings: {
      title: "إعدادات الحساب",
      first_name: "الاسم الأول",
      last_name: "اسم العائلة",
      email: "البريد الإلكتروني",
      username: "اسم المستخدم",
      password: "كلمة المرور",
      students: "الطلاب",
      teachers: "المعلمون",
      external_id: "المعرف الخارجي",
      phone: "رقم الهاتف",
      phone_required: "رقم الهاتف مطلوب",
      edit: "تعديل",
      remove: "حذف",
      add: "إضافة",
      remove_message: "هل أنت متأكد أنك تريد إزالة هذا الطالب؟",
      yes: "نعم",
      no: "لا",
      add_student: "إضافة طالب",
      close: "إغلاق",
      save: "حفظ التغييرات",
      cancel: "إلغاء",
      student_alert_message: "يجب إدخال طالب واحد على الأقل.",
      logout: "تسجيل الخروج"
    },
    TrialStatus: {
      title: "Update Trial Status",
      schoolLabel: "School",
      currentStatus: "Current Status",
      newStatus: "New Status",
      updatedSuccess: "Trial status updated successfully",
      updateError: "Failed to update trial status",
      statuses: {
        requested: "Requested",
        pending: "Pending",
        fullfilled: "Fulfilled",
        expired: "Expired",
        cancelled: "Cancelled",
        rejected: "Rejected",
        converted: "Converted"
      }
    },
    LeadStatus: {
      title: "Update Lead Status",
      schoolLabel: "School",
      currentStatus: "Current Status",
      newStatus: "New Status",
      reject: "Reject",
      updatedSuccess: "Lead status updated successfully",
      updateError: "Failed to update lead status",
      convertedNote: "This marks the lead as a customer. If a school exists, it may be set to active.",
      suppressedNote: "This suppresses the lead. You can restore it later from Suppressed.",
      statuses: {
        requested: "Requested",
        pending: "Pending",
        fullfilled: "Fulfilled",
        expired: "Expired",
        cancelled: "Cancelled",
        rejected: "Rejected",
        converted: "Converted"
      }
    },
    WelcomeEmail: {
      title: "Send welcome email?",
      schoolLabel: "School",
      districtLabel: "District",
      contactLabel: "Contact",
      emailLabel: "Email",
      subdomainLabel: "Subdomain",
      usernameLabel: "Username",
      body: "PTC Wizard will email this account's admin-site credentials and documentation links.",
      confirm: "Send email",
      cancel: "Cancel",
      success: "Welcome email sent",
      error: "Failed to send welcome email",
      tooltip: "Send welcome email"
    },
    Navbar: {
      my_meetings: "اجتماعاتي",
      language: "العربية",
      help: "مساعدة",
      account_settings: "إعدادات الحساب",
      user_management: "User Management",
      logout: "تسجيل الخروج"
    },
    SubNavbar: {
      meeting: "اجتماع",
      event: "فعالية",
      print: "طباعة",
      email: "بريد إلكتروني",
      export: "تصدير"
    },
    ConferenceCard: {
      add_edit_meetings: "إضافة/تعديل الاجتماعات",
      opening: "مفتوح",
      closed: "مغلق"
    },
    Agenda: {
      full_agenda: "الجدول الكامل",
      empty_state_title: "لم نتمكن من العثور على أي مؤتمرات لك.",
      empty_state_message: "إذا كانت لديك أي أسئلة، يرجى التواصل مع ممثل مدرستك.",
      confirmation_modal_title: "تم تأكيد الجدول",
      confirmation_modal_message: "تم تأكيد جدولك بنجاح وتم إرسال بريد إلكتروني إليك.",
      complete_button: "انتهى!"
    },
    AgendaCard: {
      room: "الغرفة غير متاحة",
      room_with_value: "الغرفة: {room}",
      virtual_meeting: "اجتماع افتراضي",
      all_conferences: "جميع المؤتمرات",
      conference: "مؤتمر",
      student: "طالب",
      meeting_with: "اجتماع مع",
      date_time: "التاريخ/الوقت",
      meeting_type: "نوع الاجتماع",
      location: "الموقع",
      comment: "ملاحظة",
      action: "إجراء",
      delete: "حذف",
      add_comment: "إضافة ملاحظة",
      join: "الانضمام للاجتماع",
      choose_meeting_type: "اختر نوع الاجتماع",
      in_person: "حضوري",
      phone: "هاتف",
      callback: "مكالمة لاحقة",
      virtual: "افتراضي",
      hybrid: "هجين",
      unavailable: "غير متاح",
      tooltip_translator: "لا يتم ضمان خدمة الترجمة، لكن ستبذل المدرسة كل جهد لضمان توفرها.",
      translator_requested: "تم طلب مترجم {language}",
      clear_translator: "إلغاء طلب المترجم",
      need_translator: "هل تحتاج إلى مترجم؟",
      choose_language: "اختر لغة"
    },
    ScheduleMatrix: {
      no_teachers_title: "لم يتم اختيار معلمين أو فرق.",
      no_teachers_message: "يرجى اختيار معلم لعرض أوقات اجتماعه.",
      choose_teachers_button: "عرض المعلمين أو الفرق المتاحة",
      choose_student: "لأي طالب؟",
      cancel: "إلغاء"
    },
    Matrix: {
      teachers: "المعلمون",
      agenda: "راجع وتابع"
    },
    DrawerTeachers: {
      teachers: "المعلمون",
      name: "الاسم",
      description: "الوصف",
      student: "طالب",
      teacher_team: "معلم/فريق",
      show_more: "عرض المزيد من المعلمين",
      show_all: "عرض جميع المعلمين في المدرسة",
      selected: "({count}) محدد",
      closeDrawer: "المتابعة إلى الجدول",
      search: "ابحث عن معلم أو فريق",
      not_available: "هذا المعلم لا يملك أي أوقات متاحة للاجتماعات في {date}."
    },
    DrawerAgenda: {
      no_meetings_title: "لا توجد اجتماعات مجدولة.",
      no_meetings_message: "بمجرد اختيار معلم وموعد، سيظهر هنا.",
      new_meeting_label: "جديد",
      cancel_button: "إلغاء",
      student_label: "طالب",
      meeting_type_location: "نوع/موقع الاجتماع",
      comment_label: "ملاحظة",
      save_comment_button: "حفظ الملاحظة",
      confirm_label: "يرجى التأكيد:",
      confirm_cancel_button: "نعم، ألغِ اجتماعي مع ",
      do_not_cancel_button: "لا تُلغِ",
      confirm_agenda_button: "تأكيد هذا الجدول",
      confirm_agenda_message_line1: "يمكنك دائمًا الرجوع وإجراء تغييرات.",
      confirm_agenda_message_line2: "سيتم إرسال جدولك إلى بريدك الإلكتروني."
    },
    EmailConsent: {
      message: "لحماية خصوصيتك، نحتاج إلى موافقتك لتلقي الرسائل على بريدك الإلكتروني.",
      consent: "موافقة"
    },
    UserManagement: {
      pageTitle: "User Management",
      pageSubtitle:
        "Add and manage school and district staff accounts. Staff sign in with school or district login using this site's account.",
      addUser: "Add user",
      editUser: "Edit user",
      loading: "Loading users…",
      emptyTitle: "No staff users yet",
      emptyMessage: "Use Add user to create a school or district staff account.",
      tableUsername: "Username",
      tableEmail: "Email",
      tableRole: "Role",
      tableActions: "Actions",
      typeSchool: "School",
      typeDistrict: "District",
      roleTeam: "Team",
      roleSchool: "School Admin",
      roleReporter: "School Reporter",
      roleDistrict: "District Admin",
      roleNoIntegration: "School Admin without Integration",
      roleNotSet: "Role not set",
      roleUnknown: "Role ({id})",
      formUsername: "Username",
      formEmail: "Email",
      formPassword: "Password",
      formNewPassword: "New password (optional)",
      formRole: "Role",
      loginHint:
        "Staff sign in with the school portal. District staff may use the district portal subdomain when applicable.",
      save: "Save",
      cancel: "Cancel",
      edit: "Edit",
      delete: "Delete",
      confirmDeleteTitle: "Remove this user?",
      confirmDeleteBody:
        "This will remove the staff account from your school. This action cannot be undone.",
      validationRequired: "Please fill in all required fields.",
      createdSuccess: "User created.",
      updatedSuccess: "User updated.",
      deletedSuccess: "User removed.",
      genericError: "Something went wrong. Please try again.",
      changeRoleTitle: "Change role",
      roleUpdatedSuccess: "Role updated.",
      deleteUserAria: "Remove user",
      formSchool: "School",
      validationSchoolRequired: "Please select a school.",
      schoolListEmpty: "No schools are available in this district."
    },
    StudentsDirectory: {
      saveLinkHousehold: "Save link household",
      saveLinkHouseholdNothing: "No changes to save.",
      saveLinkHouseholdSuccess: "Link household updated for {count} students.",
      saveLinkHouseholdError: "Could not update link household.",
      saveLinkHouseholdPartial: "Updated {saved} students; {failed} could not be saved."
    },
    Events: {
      loadError: "تعذر تحميل الفعاليات.",
      retry: "إعادة المحاولة"
    }
  }
};
